import axios from "axios";
import { API_BASE_URL } from "../../config";

const BASE = API_BASE_URL.endsWith("/api") ? API_BASE_URL : `${API_BASE_URL}/api`;

/**
 * Fetch the Post-Dated Cheque Payment report.
 * @param {Object} filters - { start_date, end_date, cheque_status, party_type }
 */
export const getPDCPayments = async (filters = {}) => {
  const params = Object.fromEntries(
    Object.entries(filters).filter(([, v]) => v !== "" && v !== null && v !== undefined && v !== "all")
  );
  const response = await axios.get(`${BASE}/reports/pdc-payments`, { params });
  return response.data;
};
